import { subjectsSortList } from '~/utils/constants';
import { resourceEduCode } from '~/api/oneBoxV3/oneBoxV3.type';

const highSchoolGradeSortRule = [
  {
    subject: '國文',
    grade: ['第一冊', '第二冊', '第三冊', '第四冊', '第五冊'],
  },
  {
    subject: '數學',
    grade: [
      '全',
      '第一冊',
      '第二冊',
      '第三冊A',
      '第三冊B',
      '第四冊A',
      '第四冊B',
      '選修甲上乙版',
      '選修乙上乙版',
      '選修甲上',
      '選修乙上',
      '選修甲下乙版',
      '選修乙下乙版',
      '選修甲下',
      '選修乙下',
    ],
  },
  {
    subject: '物理',
    grade: ['全', '選修I', '選修II', '選修III', '選修IV', '選修V'],
  },
  {
    subject: '化學',
    grade: ['全', '選修I', '選修II', '選修III', '選修IV', '選修V'],
  },
  {
    subject: '生物',
    grade: ['全', '選修I', '選修II', '選修III', '選修IV'],
  },
  {
    subject: '地球科學',
    grade: ['全'],
  },
  {
    subject: '歷史',
    grade: ['第一冊', '第二冊', '第三冊', '選修I', '選修II'],
  },
  {
    subject: '地理',
    grade: ['第一冊', '第二冊', '第三冊', '選修I', '選修II'],
  },
  {
    subject: '公民與社會',
    grade: ['第一冊', '第二冊', '第三冊', '選修I', '選修II'],
  },
];

export const sortHighSchoolGrade = (
  subject: string,
  grades: string[],
): string[] => {
  const subjectSort = highSchoolGradeSortRule.find(
    item => item.subject === subject,
  );
  if (!subjectSort) {
    return grades;
  }

  const sortedGrades = [...grades].sort((a, b) => {
    const gradeAIndex = subjectSort.grade.indexOf(a);
    const gradeBIndex = subjectSort.grade.indexOf(b);

    if (gradeAIndex === -1) return 1;
    if (gradeBIndex === -1) return -1;

    return gradeAIndex - gradeBIndex;
  });

  return sortedGrades;
};

export const sortGrade = (grades: string[]) => {
  if (!grades) return;
  const sorted = [...grades].sort((a, b) => {
    const numA = parseInt(a.replace(/[^0-9]/g, ''));
    const numB = parseInt(b.replace(/[^0-9]/g, ''));

    return numA - numB;
  });
  return sorted;
};

export type TEduCode = '國小' | '國中' | '高中';

export const getEduCode = (code: string | undefined | null): TEduCode => {
  const validCodes: TEduCode[] = ['國小', '國中', '高中'];
  if (validCodes.includes(code as TEduCode)) {
    return code as TEduCode;
  }
  return '國小';
};

export const subjectsSort = (list: string[], level: string): string[] => {
  let order = [];
  if (list.length < 1) {
    list = subjectsSortList.E;
  }
  switch (level) {
    case resourceEduCode.E:
      order = subjectsSortList.E;
      break;
    case resourceEduCode.J:
      order = subjectsSortList.J;
      break;
    case resourceEduCode.H:
      order = subjectsSortList.H;
      break;
    default:
      order = subjectsSortList.E;
      break;
  }
  const orderMap = new Map(order.map((subject, index) => [subject, index]));
  return [...list].sort((a, b) => {
    const indexA = orderMap.get(a);
    const indexB = orderMap.get(b);
    if (indexA === undefined && indexB === undefined) {
      return 0;
    }
    if (indexA === undefined) {
      return 1;
    }
    if (indexB === undefined) {
      return -1;
    }
    return indexA - indexB;
  });
};

/**
 * 學年度下拉顯示序：民國年數字「新→舊」，同年「下」接「上」（下學期視為較新）。
 */
export const sortSchoolYearsNewestFirstReadable = (yearLists: string[]) => {
  const yearsCopy = [...yearLists];
  yearsCopy.sort((a, b) => {
    const yearA = parseInt(a.substring(0, 3), 10);
    const termA = a.substring(3);

    const yearB = parseInt(b.substring(0, 3), 10);
    const termB = b.substring(3);

    if (yearA !== yearB) {
      return yearB - yearA;
    }

    if (termA === '下' && termB === '上') {
      return -1;
    }
    if (termA === '上' && termB === '下') {
      return 1;
    }

    return 0;
  });

  return yearsCopy;
};

/** 前台資源列學年度：同上排序，僅保留最近 6 個選項以維持版面精簡。 */
export const yearSortAndReverse = (yearLists: string[]) =>
  sortSchoolYearsNewestFirstReadable(yearLists).slice(0, 6);
